import { render, staticRenderFns } from "./TutorialFakeFight.vue?vue&type=template&id=e495d35e&scoped=true"
import script from "./TutorialFakeFight.vue?vue&type=script&lang=js"
export * from "./TutorialFakeFight.vue?vue&type=script&lang=js"
import style0 from "./TutorialFakeFight.vue?vue&type=style&index=0&id=e495d35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e495d35e",
  null
  
)

export default component.exports